import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import SignupSection from './SignupSection';
import LoginSection from './LoginSection';
import { commonStyles } from '../styles/commonStyles';

interface UnauthenticatedViewProps {
  onAuthenticate: () => void;
}

const UnauthenticatedView: React.FC<UnauthenticatedViewProps> = ({
  onAuthenticate,
}) => {
  return (
    <Box sx={commonStyles.pageContainer}>
      <Box sx={commonStyles.mainCard}>
        {/* Main Header */}
        <Box sx={commonStyles.header}>
          <Box
            component="img"
            src="/PRP1.svg"
            alt="Servicer Portal Logo"
            sx={commonStyles.logo}
          />
          <Typography variant="h3" sx={commonStyles.headerTitle}>
            Servicer Portal
          </Typography>
        </Box>

        {/* Content sections */}
        <Box sx={commonStyles.contentWrapper}>
          <SignupSection />

          <Divider orientation="vertical" flexItem sx={commonStyles.divider} />

          <LoginSection onAuthenticate={onAuthenticate} />
        </Box>
      </Box>
    </Box>
  );
};

export default UnauthenticatedView;
